<div class="part-search-modal">
  <div class="flex">
    <div class="flex-1 p-4">
      <form [formGroup]="searchFormGroup" (submit)="submit()">
        <div class="flex gap-2">
          <fip-form>
            <mat-form-field>
              <mat-label>Article Number</mat-label>
              <input
                matInput
                placeholder="e.g. P1234"
                formControlName="articleNumber"
              />
            </mat-form-field>
          </fip-form>
          <fip-form formType="daterange-picker" class="flex-1">
            <mat-form-field class="w-full">
              <mat-label>Production Date</mat-label>
              <mat-date-range-input
                [rangePicker]="production"
                [comparisonStart]="searchFormGroup.value.productionStart"
                [comparisonEnd]="searchFormGroup.value.productionEnd"
              >
                <input
                  matStartDate
                  placeholder="Start date"
                  formControlName="productionStart"
                />
                <input
                  matEndDate
                  placeholder="End date"
                  formControlName="productionEnd"
                />
              </mat-date-range-input>
              <mat-datepicker-toggle
                matIconSuffix
                [for]="production"
              ></mat-datepicker-toggle>
              <mat-date-range-picker #production></mat-date-range-picker>
            </mat-form-field>
          </fip-form>
          <fip-form formType="submit">
            <fip-button
              [loading]="(searchLoading$ | async)!"
              (clickEvent)="submit()"
              label="Search"
              backgroundColor="black"
              textColor="white"
              classes="mt-3 px-3 py-2 sm:ml-3 sm:mt-0 sm:w-auto shadow-sm text-sm"
            ></fip-button>
          </fip-form>
        </div>
      </form>

      @if (((searchLoading$ | async)) === false) { @if (searchResult) {
      <div data-cy="spc-article-search-result" class="pt-2">
        <fip-table
          [data]="searchResult.results"
          [displayedColumns]="displayedColumns"
          [columns]="columns"
          [paginated]="true"
          [contained]="true"
          (rowClicked)="rowClicked($event)"
        ></fip-table>
      </div>
      } @else {
      <div data-cy="spc-article-search-no-result" class="pt-2">
        No results found.
      </div>
      } }
    </div>
    <div
      data-cy="serial-numbers-list"
      class="flex-1 self-stretch bg-gray-100 px-4 pb-10 pt-4"
    >
      <h4 class="text-base font-semibold leading-6 text-gray-900">Recent</h4>
      @if ((savedArticles$ | async)?.length === 0) {
      <p class="text-sm text-gray-500">You have no recent search.</p>
      } @else { @for (article of savedArticles$ | async; track article) {
      <button
        class="group mt-2 flex items-center text-left text-sm"
        (click)="submit(article)"
      >
        <p
          class="whitespace-nowrap text-sm font-semibold leading-6 text-gray-900 group-hover:text-gray-500"
        >
          - {{ article.articleNumber }}
        </p>
        <p
          class="ml-1 bg-gray-50 px-1.5 py-0.5 text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-500/10"
        >
          {{ article.productionFrom }} - {{ article.productionUntil }}
        </p>
      </button>
      } }
    </div>
  </div>
</div>
